
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner-resources",
      function () {
        return require("private-next-pages/partner-resources/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner-resources"])
      });
    }
  